import { Home, Menu, Newspaper, X } from 'lucide-react';
import React from 'react';
import { Page, SiteConfig } from '../types';
import { IconRenderer } from './IconRenderer';

interface HeaderProps {
  siteConfig: SiteConfig | null;
  pages: Page[];
  mobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
  onHomeClick: () => void;
  onArticlesClick: () => void;
  onPageClick: (page: Page) => void;
}

export const Header: React.FC<HeaderProps> = ({
  siteConfig,
  pages,
  mobileMenuOpen,
  onToggleMobileMenu,
  onHomeClick,
  onArticlesClick,
  onPageClick,
}) => (
  <header className="bg-black text-white sticky top-0 z-50 shadow-xl">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="flex items-center py-6">
        <img src="./vaakuna.svg" alt="vaakuna" className="w-20 h-20 mr-2" />
        <button onClick={onHomeClick} className="focus:outline-none">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-black tracking-tighter hover:text-yellow-500 transition-colors uppercase">
            {siteConfig?.siteName || ''}
          </h1>
        </button>

        {/* Mobile menu button */}
        <button
          onClick={onToggleMobileMenu}
          className="md:hidden p-2 ml-auto"
        >
          {mobileMenuOpen ? <X size={32} strokeWidth={3} /> : <Menu size={32} strokeWidth={3} />}
        </button>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-10 pb-4">
        <button
          onClick={onHomeClick}
          className="text-white hover:text-yellow-500 font-headline font-black transition-colors text-xl uppercase tracking-wide flex items-center gap-2"
        >
          <Home size={22} strokeWidth={3} />
          Koti
        </button>
        <button
          onClick={onArticlesClick}
          className="text-white hover:text-yellow-500 font-headline font-black transition-colors text-xl uppercase tracking-wide flex items-center gap-2"
        >
          <Newspaper size={22} strokeWidth={3} />
          Uutiset
        </button>
        {pages.map(page => (
          <button
            key={page.id}
            onClick={() => onPageClick(page)}
            className="text-white hover:text-yellow-500 font-headline font-black transition-colors text-xl uppercase tracking-wide flex items-center gap-2"
          >
            <IconRenderer iconName={page.icon} size={22} strokeWidth={3} />
            {page.title}
          </button>
        ))}
      </nav>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="md:hidden pb-8 space-y-6 border-t border-gray-800 pt-8">
          <button
            onClick={onHomeClick}
            className="flex gap-2 items-center w-full text-left text-2xl font-display font-black text-white hover:text-yellow-500 py-2 uppercase tracking-wide"
          >
            <Home size={22} strokeWidth={3} />
            Koti
          </button>
          <button
            onClick={onArticlesClick}
            className="flex gap-2 items-center w-full text-left text-2xl font-display font-black text-white hover:text-yellow-500 py-2 uppercase tracking-wide"
          >
            <Newspaper size={22} strokeWidth={3} />
            Uutiset
          </button>
          {pages.map(page => (
            <button
              key={page.id}
              onClick={() => onPageClick(page)}
              className="flex gap-2 items-center w-full text-left text-2xl font-display font-black text-white hover:text-yellow-500 py-2 uppercase tracking-wide"
            >
              <IconRenderer iconName={page.icon} size={22} strokeWidth={3} />
              {page.title}
            </button>
          ))}
        </nav>
      )}
    </div>
  </header>
);